import { Component } from '@angular/core';
import { Subject } from 'rxjs';

import { RxComponent } from '../../../../core/components/common/rx.component';
import { EmployeeService } from './employee.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { ConfigService } from '../../../../core/services/config.service';
import { ActionClickEvent } from '../../../../shared/components/dynamic-grid/dynamic-grid.component';

@Component({
  selector: 'itpx-employees',
  templateUrl: './employees.component.html',
  styleUrls: ['./employees.component.css']
})
export class EmployeesComponent extends RxComponent {

    private url: string;
    private detailsRoute: string = '/agora/account-data/employees/{{key}}/details';
    private fields: Array<any> = [
        {
            title: 'First Name',
            name: 'firstName',
            config: {
                type: 'link',
                route: this.detailsRoute,
                key: 'id'
            }
        }, {
            title: 'Last Name',
            name: 'lastName'
        }, {
            title: 'Email',
            name: 'email'
        }, {
            title: 'Function',
            name: 'function'
        }, {
            title: 'Domains',
            name: (data: any) => {
                if (data['domains'] && data['domains'][0]) {
                    return [data['domains'][0].name];
                } else {
                    return '';
                }
            }
        }, {
            title: '',
            config: {
                type: 'action',
                actions: [
                    {
                        name: 'invite',
                        label: 'Invite',
                        condition: (employee: any) => {
                            return !employee.invited;
                        }
                    }
                ]
            }
        }
    ];
    
    private refresh = new Subject<any>();

    constructor(
        private configService: ConfigService,
        private service: EmployeeService,
        private notificationService: NotificationService
    ) {
        super();
        this.url = this.configService.get('server').url + this.configService.get('endpoints').agora.employees.list.api;
    }

    private onActionClicked(e: ActionClickEvent) {
        if (e.action == 'invite') {
            this.service.invite(e.item)
                .subscribe(
                    body => {
                        this.notificationService.success('Successfully invited the employee', 'Success');
                        this.refresh.next(true);
                    }
                );
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/agora/components/account-data/employees/employees.component.ts